import React, { Component } from "react";
import ServiciosAlumnoTabla from "./ServiciosAlumnoTabla";
import { connect } from "react-redux";
import { getServiciosAlumnoList } from './ServiciosAlumnoAction'
import { withRouter } from 'react-router-dom';

class ServiciosAlumnoContainer extends Component {

    componentDidMount() {
        //console.log("ServiciosAlumnoContainer");
        this.props.dispatch(getServiciosAlumnoList());
    }

    render() {
        return (
            <div>
                <ServiciosAlumnoTabla />
            </div>
        );
    }

}

export default connect()(ServiciosAlumnoContainer);
